import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Building2 } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const CUR = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "AED " };

export function JobCard({ job, index = 0, testid }) {
  const { t } = useLang();
  const cur = CUR[job.currency] || "$";
  const salary = job.salary_min
    ? `${cur}${Number(job.salary_min).toLocaleString()} - ${cur}${Number(job.salary_max || job.salary_min).toLocaleString()}`
    : "Competitive";
  return (
    <div
      data-testid={testid || `job-card-${job.id}`}
      className="gjt-card p-5 gjt-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="truncate font-display text-base font-bold text-navy">{job.title}</h3>
          <p className="mt-0.5 flex items-center gap-1 text-sm text-slate-600">
            <Building2 className="h-3.5 w-3.5" /> {job.company_name}
          </p>
        </div>
        <span className="shrink-0 rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-bold uppercase text-emerald-600 capitalize">
          {job.work_mode}
        </span>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
        <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {job.city}, {job.country}</span>
        <span className="capitalize">{job.employment_type}</span>
      </div>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {(job.skills || []).slice(0, 4).map((s) => (
          <span key={s} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-600">{s}</span>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between">
        <span className="text-sm font-bold text-navy">{salary}</span>
        <Link to={`/jobs/${job.id}`} data-testid={`view-job-${job.id}`} className="rounded-xl bg-navy px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-navy-dark">
          {t("view_job")}
        </Link>
      </div>
    </div>
  );
}
